import React from 'react'

import { usePSNavigate } from '../../hooks/usePSNavigate'
import LeftArrow from '../../icons/left-arrow.svg?react'
import { RecordFactory } from '../../models/RecordFactory'
import { RecordNotFoundError } from '../../models/errors/RecordNotFoundError'
import { currencyFormat } from '../../utils/numbers'
import { ComponentData } from '../../utils/typing'
import { PocketComponent, PocketComponentProps, usePSComponent } from '../PocketComponent'
import { PSButton, PSButtonPrimary } from '../app/PSButton'

type BillingHistory = {
    details: string
    value: string | number
    id: string
}

const viewWillAppear = async (base: PocketComponent) => {
    const result = await RecordFactory.getInstance().fetchPremiumHistory(base.me)
    if (!result.ok) {
        base.logAndDisplayError(result.error)
        return new RecordNotFoundError()
    }

    const title = result.value.header_title as string
    const billingHistory = result.value.items as BillingHistory[]

    return { title, billingHistory }
}

const render = ({ data }: PocketComponentProps<ComponentData<typeof viewWillAppear>>) => {
    if (data instanceof RecordNotFoundError) {
        throw data
    }

    const navigate = usePSNavigate()

    return (
        <div className="supportSettings">
            <div className="header">
                <PSButton className="left" onClick={() => navigate(-1)}>
                    <LeftArrow />
                </PSButton>
                <h1 className="title">Cancel your plan?</h1>
                <div className="right">
                    <PSButton onClick={() => navigate('features')}>Cancel plan</PSButton>
                    <PSButtonPrimary onClick={() => navigate('/', { replace: true })}>
                        Never mind
                    </PSButtonPrimary>
                </div>
            </div>
            <div className="separator" />
            <p className="details">
                Cancelling permanently removes your content. To keep your content you can pause your
                plan.
            </p>

            <p className="title details center">{data.title}</p>

            {data.billingHistory.map(({ id, value, details }) => (
                <div className="supportCard" key={`billing-history-data-${id}`}>
                    <div className="title">
                        {id === 'income' ? currencyFormat(value) : value.toLocaleString()}
                    </div>
                    <div className="details">&nbsp;{details}</div>
                </div>
            ))}
        </div>
    )
}

export const DowngradePlanPage = usePSComponent(render, viewWillAppear)
